module.exports = __webpack_public_path__ + "assets-cabinet/img/history-icon.d1c4462a.svg";